export function importExcelHelper(callback, extAllow, filesize) {
  
  if (!extAllow) {
    extAllow = '.xls,.xlsx'
  }
  if (!filesize) {
    filesize = 30
  }
  const uploader = document.createElement('input')
  uploader.type = 'file'
  uploader.style.setProperty("display","none")
  document.body.appendChild(uploader);
  uploader.onchange = () => {
    if (extAllow) {
      var extAllowList = extAllow.split(',')
      if (
        extAllowList.filter(item => {
          return uploader.files[0].name
            .toUpperCase()
            .endsWith(item.toUpperCase())
        }).length == 0
      ) {
        this.$message(this.$t('messageCommon.onlyExtensions',[extAllow]))
        return
      }
    }
    if (this.sizeForbid * 1024 * 1024 < uploader.files[0].size) {
      this.$message(this.$t('messageCommon.fileMaxSize',[this.sizeForbid]))
      return
    }
    if (callback) {
      document.body.removeChild(uploader);
      callback(uploader.files[0])
    }
  }
  setTimeout(() => {
    uploader.click()
  }, 0)
}

export function importAllHelper(callback, filesize) {
  if (!filesize) {
    filesize = 30
  }
  const uploader = document.createElement('input')
  uploader.type = 'file'
  uploader.style.setProperty("display","none")
  document.body.appendChild(uploader);
  uploader.onchange = () => {
    if (this.sizeForbid * 1024 * 1024 < uploader.files[0].size) {
      this.$message(this.$t('messageCommon.fileMaxSize',[this.sizeForbid]))
      return
    }
    if (callback) {
      document.body.removeChild(uploader);
      callback(uploader.files[0])
    }
  }
  setTimeout(() => {
    uploader.click()
  }, 0)
}
